var _requestAnimationFrame

var inView_elements = [];
var inView_items = [];
var inView_elements_refresh = function(){
	inView_elements =  $('.page_row, .grid_cell_wrapper, .cell_content, .scrollspy');
	inView_items =  $('.module_wrapper .items .item');
}

function scrolled_updater()
{
	var wH = $(window).height();
	var wT = $(window).scrollTop();
	var wB = $(window).scrollTop() + wH;

	// ----------------------------------------------------------------------------------------------------------------
	// Injection de classe sur le body
	// ----------------------------------------------------------------------------------------------------------------
	let bodyClass = $('body').attr('class');
	let scrollClass = [];
	var Sm = 40;

	var S = Math.min(Sm,Math.floor($(window).scrollTop()/100));
	for(let i=1; i<=S; i++)
		scrollClass.push('scroll-'+(i*100))

	if($(window).scrollTop()>10)
		scrollClass.push('scrolled')
	else
		scrollClass.push('not_scrolled')

	$('.page_row').each(function(i){
		if($(this).offset().top < wB && $(this).offset().top + $(this).outerHeight() > wT)
		{
			var ref = $(this).attr('row-code')
			if(ref)
				scrollClass.push('in__'+ref);
			scrollClass.push('in-row-'+i);
		}
	})

	// base cleanup
	bodyClass = bodyClass.replace(/ +/,' ');
	bodyClass = bodyClass.replace(/ +$/,'');
	bodyClass = bodyClass.replace(/^ +/,'');

	// update class string + cleanup
	let _bodyClass = ' '+bodyClass;
	_bodyClass = _bodyClass.replace(/ not_scrolled/g,' ');
	_bodyClass = _bodyClass.replace(/ scrolled/g,' ');
	_bodyClass = _bodyClass.replace(/ scroll-[0-9]+/g,' ');
	_bodyClass = _bodyClass.replace(/ in__[^ ]+/g,' ');
	_bodyClass = _bodyClass.replace(/ in-row-[0-9]+/g,' ');
	_bodyClass = _bodyClass.replace(/ +/,' ');
	_bodyClass = _bodyClass.replace(/ +$/,'');
	_bodyClass = _bodyClass.replace(/^ +/,'');
	_bodyClass = _bodyClass + ' ' + scrollClass.join(' ');


	// add scroll classes with 1 operation only on real change
	if(bodyClass != _bodyClass)
	{
		$('body').attr('class',_bodyClass);
	}

	// ----------------------------------------------------------------------------------------------------------------
	// injection de classe sur certains éléments en fonction de leur position
	// ----------------------------------------------------------------------------------------------------------------
	var inViewClassInjection = function(el,i,className) {
		if($(el).offset().top < wB)
			$(el).addClass(className);
		else
			$(el).removeClass(className);

		if($(el).offset().top < wB - wH*0.3)
			$(el).addClass(className+'-sm');
		else
			$(el).removeClass(className+'-sm');

		if($(el).offset().top < wB - wH*0.5)
			$(el).addClass(className+'-md');
		else
			$(el).removeClass(className+'-md');

		if($(el).offset().top < wB - wH*0.7)
			$(el).addClass(className+'-lg');
		else
			$(el).removeClass(className+'-lg');
	}

	if(inView_elements && inView_elements.length) { inView_elements.each(function(i) { inViewClassInjection(this,i,'in-view')     }) }
	if(inView_items    && inView_items.length)    { inView_items.each(function(i)    { inViewClassInjection(this,i,'itm-in-view') }) }
}



/* Optimized initialisation and handler using AnimationFrame */

$( document ).ready(function() {
	window.setTimeout(_init, 0)
});

function _init() {
	console.log('HAPI.Scrolled :: init')
	window.addEventListener('scroll', _handler)
	window.addEventListener('resize', _handler)
	window.setTimeout(inView_elements_refresh,100);
	window.setInterval(inView_elements_refresh,2000);
	window.setTimeout(scrolled_updater, 1000);
}

function _handler () {
	_requestAnimationFrame(scrolled_updater)
}

_requestAnimationFrame = window.requestAnimationFrame ||
						 window.webkitRequestAnimationFrame ||
						 window.mozRequestAnimationFrame ||
						 function (callback) {
							window.setTimeout(callback, 0)
						 }